// Shared UK (en-GB) currency formatting used everywhere Estatel AI displays money.
//
// Rationale: the app previously mixed `£${x.toFixed(2)}`, `&pound;`,
// `'\u00A3'`, and `Intl.NumberFormat` inline, producing inconsistent
// rendering (e.g. `£12300.00` vs `£12,300.00`). This helper is the single
// source of truth — pass anything (number / string / null / Decimal) in,
// get a tidy UK-formatted string out.
//
// Usage:
//   formatCurrency(12300)         → "£12,300.00"
//   formatCurrency(12300, { decimals: 0 }) → "£12,300"
//   formatCurrency(12300.456, { decimals: 4 }) → "£12,300.4560"
//   formatCurrency(null)          → "—"
//   formatCurrency("1500.50")     → "£1,500.50"
//

const GBP = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatCurrency(amount, options = {}) {
  const { decimals, fallback = '—' } = options;

  if (amount === null || amount === undefined || amount === '') return fallback;

  const n = typeof amount === 'number' ? amount : Number(amount);
  if (!Number.isFinite(n)) return fallback;

  if (typeof decimals === 'number') {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(n);
  }
  return GBP.format(n);
}

// Whole-number formatter — keeps the £ symbol off (useful for tokens or
// non-currency integers like "1,234 tokens").
const INT_GB = new Intl.NumberFormat('en-GB');

export function formatInteger(value, fallback = '—') {
  if (value === null || value === undefined || value === '') return fallback;
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return fallback;
  return INT_GB.format(Math.round(n));
}
